export function createDefaultEmptyComponent(_ref) {
  var createElement = _ref.createElement,
    Fragment = _ref.Fragment;
  var _ref2 = createElement(Fragment, null, "No results");
  return function DefaultEmpty() {
    return _ref2;
  };
}